__turbopack_context__.v({
  "L": "_6xyMDa_L",
  "M": "_6xyMDa_M",
  "anchor": "_6xyMDa_anchor",
  "data": "_6xyMDa_data",
  "default": "_6xyMDa_default",
  "hidden": "_6xyMDa_hidden",
  "icon": "_6xyMDa_icon",
  "preview-card": "_6xyMDa_preview-card",
  "slideInAnimation": "_6xyMDa_slideInAnimation",
  "specs": "_6xyMDa_specs",
  "specs-item": "_6xyMDa_specs-item",
  "square": "_6xyMDa_square",
  "subtitle": "_6xyMDa_subtitle",
  "thumb": "_6xyMDa_thumb",
  "title": "_6xyMDa_title",
  "title-collection": "_6xyMDa_title-collection",
  "title-container": "_6xyMDa_title-container",
  "video-preview": "_6xyMDa_video-preview",
  "video-preview--visible": "_6xyMDa_video-preview--visible",
  "with-preview": "_6xyMDa_with-preview",
});
